export function returnNever(value: never): never {
    return value;
}

export function assertNever(_: never): never {
    throw new Error('Unhandled value');
}
